<template>
  <div
    ref="event"
    class="simple-event full-width"
    :data-test-id="`simple-event-${event.title}`"
  >
    <TruncateText :expand="false">
      <i class="fa-regular fa-calendar-xmark text-link" />
      <span class="link">{{ event.title }}</span>
    </TruncateText>
  </div>
</template>

<script lang="ts">
import TruncateText from "@/components/TruncateText.vue";
export default {
  components: {
    TruncateText
  },
  props: {
    event: {
      type: Object,
      default: null
    }
  },
  mounted() {
    tippy(this.$refs.event.parentElement, { content: this.event.title });
  }
};
</script>

<style lang="scss" scoped></style>
